import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import './index.css';

function ScrollTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function NotFound() {
  return (
    <main style={{ paddingTop:'62px', minHeight:'80vh', display:'flex', alignItems:'center', justifyContent:'center', textAlign:'center', flexDirection:'column', gap:'20px' }}>
      <div style={{ fontSize:'5rem' }}>🔮</div>
      <h1 style={{ fontFamily:'Orbitron,monospace', fontSize:'2rem', color:'#fff', textShadow:'0 0 20px #c026d3' }}>404</h1>
      <p style={{ color:'rgba(255,255,255,0.6)', marginBottom:'8px' }}>This level doesn't exist!</p>
      <a href="/" style={{ background:'linear-gradient(135deg,#c026d3,#7c3aed)', color:'#fff', padding:'12px 24px', borderRadius:'12px', fontWeight:'700', textDecoration:'none', boxShadow:'0 0 20px rgba(192,38,211,0.4)' }}>
        ← Back to Game
      </a>
    </main>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}
